'use client'

import { addBundleToMatterHistory } from './addBundleToMatterHistory'
import { confirm as reactConfirm } from '@repo/ui/Confirm'
import { deleteBundle } from './deleteBundle'
import { downloadBundle } from './downloadBundle'
import { editBundle } from './editBundle'
import { LoadingState } from '@repo/ui/LoadingState'
import { openInBundledocs } from './openInBundledocs'
import { MenuDivider, MenuItem, useMenuState } from '@szhsin/react-menu'
import { MoreVertIcon } from '@repo/ui/MoreVertIcon'
import { PopupWithBackdrop } from '@repo/ui/PopupWithBackdrop'
import { useLookupsStore } from '@repo/store/useLookupsStore'
import { useNavigate } from 'react-router-dom'
import { useRef, useState } from 'react'
import IconButton from '@mui/material/IconButton'
import MUIStack from '@mui/material/Stack'
type MoreMenuCardProps = {
  rowData?: any
}

export const MoreMenuCard = ({ rowData }: MoreMenuCardProps) => {
  const [menuState, toggleMenu] = useMenuState({ transition: true })
  const [loading, setLoading] = useState(false)
  const ref = useRef(null)
  const navigate = useNavigate()
  const { enableBundledocs } = useLookupsStore()

  const handleEditBundle = () => {
    editBundle(navigate, rowData)
    toggleMenu(false)
  }

  const handleDownloadBundle = async () => {
    toggleMenu(false)
    setLoading(true)
    try {
      await downloadBundle(rowData)
    } finally {
      setLoading(false)
    }
  }

  const handleAddToMatterHistory = async () => {
    toggleMenu(false)
    setLoading(true)
    try {
      await addBundleToMatterHistory(rowData)
    } finally {
      setLoading(false)
    }
  }

  const handleDeleteBundle = async () => {
    const proceed = await reactConfirm('Are you sure you want to delete this bundle?')
    if (!proceed) return

    toggleMenu(false)
    setLoading(true)
    try {
      await deleteBundle(rowData)
    } finally {
      setLoading(false)
    }
  }

  const handleOpenInBundledocs = async () => {
    toggleMenu(false)
    setLoading(true)
    try {
      await openInBundledocs(rowData)
    } finally {
      setLoading(false)
    }
  }

  return (
    <MUIStack>
      {loading ? (
        <LoadingState />
      ) : (
        <IconButton
          data-testid="DocumentBundlesMoreMenu"
          size="small"
          aria-label="More actions"
          onClick={() => toggleMenu(true)}
          ref={ref}
        >
          <MoreVertIcon sx={{ height: '20px', width: '20px' }} />
        </IconButton>
      )}

      <PopupWithBackdrop menuState={menuState} anchorRef={ref} toggleMenu={toggleMenu} className="masterActionMenu">
        <MenuItem onClick={handleEditBundle}>Edit bundle</MenuItem>
        <MenuItem onClick={handleAddToMatterHistory}>Upload bundle to matter history</MenuItem>
        <MenuItem onClick={handleDownloadBundle}>Download bundle</MenuItem>
        {enableBundledocs && <MenuItem onClick={handleOpenInBundledocs}>Open in bundledocs</MenuItem>}
        <MenuDivider />
        <MenuItem onClick={handleDeleteBundle} className="szh-menu__item__delete">
          Delete bundle
        </MenuItem>
      </PopupWithBackdrop>
    </MUIStack>
  )
}
